export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_11.ee19a83c.png";